// MUI
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import BusinessIcon from "@mui/icons-material/Business";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";

export const UserBranches = ({ branches }) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 500,
        mt: 2,
      }}
    >
      <Typography
        sx={{
          marginBottom: "16px",
        }}
      >
        Below is a list of all the branches you have access to.
      </Typography>
      <Typography>
        If you need any branches added or removed from your account, please
        contact support.
      </Typography>
      <List
        sx={{
          mt: 2,
        }}
      >
        {Object.entries(branches).map(([key, value]) => (
          <Box key={key}>
            <ListItem
              alignItems="flex-start"
              sx={{
                ml: Number(value.indentation),
              }}
            >
              <ListItemAvatar>
                <Avatar
                  alt={key}
                  sx={{
                    bgcolor: "primary.main",
                  }}
                >
                  {Number(value.indentation) === 0 ? (
                    <BusinessIcon />
                  ) : (
                    <MapsHomeWorkIcon />
                  )}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={value.branchId}
                secondary={
                  <>
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        display: "inline",
                      }}
                    >
                      {value.branchName}
                    </Typography>
                  </>
                }
              />
            </ListItem>
            <Divider variant="inset" component="li" />
          </Box>
        ))}
      </List>
    </Box>
  );
};
